import { Grid, Stack, TextField } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { FormField, IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

export type OrderNotesSubFormType = {
  notes?: string | null
  operationalInstructions?: string | null
}

export const OrderNotesSubForm = observer(
  ({
    formStore,
    initialValues,
  }: {
    formStore: IFormStore<OrderNotesSubFormType>
    initialValues?: Partial<OrderNotesSubFormType>
  }) => {
    const { t } = useTranslate()

    return (
      <Stack gap={2}>
        <Grid size={12}>
          <FormField formStore={formStore} name='notes' initialValue={initialValues?.notes ?? ''}>
            {store => (
              <TextField
                {...store.props}
                fullWidth
                label={`${t('controlRoomNotes', 'Control room notes')}`}
                variant='outlined'
                helperText={t('notesForControlRoom', 'General notes for the control room')}
                type='text'
                name='notes'
              />
            )}
          </FormField>
        </Grid>
        <Grid size={12}>
          <FormField
            formStore={formStore}
            name='operationalInstructions'
            initialValue={initialValues?.operationalInstructions ?? ''}
          >
            {store => (
              <TextField
                {...store.props}
                fullWidth
                label={`${t('operationalInstructions', 'Operational instructions')}`}
                variant='outlined'
                helperText={t(
                  'thisNoteWillAppearOnOperatorsCard',
                  `This note will appear on operator's card`,
                )}
                type='text'
                name='operationalInstructions'
              />
            )}
          </FormField>
        </Grid>
      </Stack>
    )
  },
)
